import uuid from "uuid";
import clone from 'lodash/clone';

//todo sqft-react
import EventManager from "./../../store/sqftEventManager";
import PointRadius from "./overlays/pointRadius";
import workspace from "../workspace";
import sqftConfig from "../../store/sqftConfig";
import COLOR_THEMES, {COLOR} from "../../store/colorThemes";
// import Radius from "../controls/radius";
import FitSize from "../../../../helpers/sqftFitSize";
import SqftStore from "../../store/sqftStore";
import store from "../../../../../../store";
import sqftShape from "./sqftShape";
import line from "./line";
import {
  getMidPoint,
  getPointOnTheLine,
  isDisabledInPopupWithParents
} from "../../../../helpers/sqftHelper";
import config from "../../store/sqftConfig";
import {isDisabledInPopupShouldBeHidden, SIDEBAR_NAVIGATION_BUTTONS} from "../../../../constants";
import MiteredOverlay from "./overlays/mitered";
import {getAngleBetween3Points} from "../../../../helpers/shapeHelper";
//import MiteredOverlay from "../overlays/mitered";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {isSFTCabinetsGroup} from "../../../../helpers/sqftNavigationHelper";
import {renderResetSeamPopup, shouldResetSlabModePopupOnPointMoveBeDisplayed} from "../../canvasPopup/resetSeam";
import sqftShapeManager from "../../store/sqftShapeManager";

export const allowedNavItemsForMovingPoint = [
  SIDEBAR_NAVIGATION_BUTTONS.freeDraw,
  SIDEBAR_NAVIGATION_BUTTONS.resize
];

export default function (x, y, direction, corner, canBeMoved = true) {
  //private variables
  let self = this,
    parent = null,
    state = {
      isMovable: false,
      mouseDown: false,
      mouseDownPosition: {},
      selected: false,
      isHovering: false,
      mousePos: {},
      pointWasMoved: false,
      canBeMoved,
      miteredFeatureId: null,
    },
    fillStyle = "#E3E1E3",
    fillStyleEdge = COLOR_THEMES[sqftConfig.activeTheme].active,
    fillStyleWhite = "#FFFFFF",
    fillStyleBlack = "#4a4a4a",
    fillStyleDelete = "#e77f8d", //"rgba(253,2,33, 0.5)",
    fillStyleBlue = COLOR_THEMES[sqftConfig.activeTheme].primary,
    //highlightFillStyle = "rgba(0,255,0,0.5)",
    //hoverFillStyle = "#D0011B",
    radiusFillStyle = "#b263a8",
    translateX,
    translateY,
    pointRadiusOverlay = null;
  //public properties
  this.id = uuid();
  this.pos = {x, y};
  this.posSlab = {
    x: x ? JSON.parse(JSON.stringify(x)) : 0,
    y: y ? JSON.parse(JSON.stringify(y)) : 0
  };
  Object.defineProperty(this, "x", {
    set: (value) => {
      setPointWasChangedInRegularMode();
      if (SqftStore.isRegularMode() && shouldResetSlabModePopupOnPointMoveBeDisplayed(this.getGrandParent())) {
        renderResetSeamPopup(this.getGrandParent())
      }
      return SqftStore.isSlabMode()  ? this.posSlab.x = parseFloat(value) : this.pos.x = parseFloat(value);
    },
    get: () => {
      if (this.pos === undefined) {
        console.log("point pos not defined");
        return 0;
      }
      return SqftStore.isSlabMode()  ? this.posSlab.x : this.pos.x;
    }
  });
  Object.defineProperty(this, "y", {
    set: (value) => {
      setPointWasChangedInRegularMode();
      if (SqftStore.isRegularMode() && shouldResetSlabModePopupOnPointMoveBeDisplayed(this.getGrandParent())) {
        renderResetSeamPopup(this.getGrandParent())
      }
      return SqftStore.isSlabMode()  ? this.posSlab.y = value : this.pos.y = value;
    },
    get: () => {
      if (this.pos === undefined) {
        console.log("point pos not defined");
        return 0;
      }
      return SqftStore.isSlabMode()  ? this.posSlab.y : this.pos.y;
    }
  });
  this.arcLength = 0;
  this.angle = 0;
  this.featureId = null;
  this.pointDirection = direction;
  this.corner = corner;
  this.renderAngleCircle = false;
  this.renderAngleArc = false;
  this.angleIsChanged = false;
  this.layout = null;
  this.rotateAnglePart = null; // link to the whole rotation part
  this.exportAndImportProperties = [
    "id", "x", "y", "pos", "posSlab", "arcLength", "angle", "pointDirection", "corner", "rotateAnglePart", "angleIsChanged",
    "renderAngleCircle", "renderAngleArc", "featureId"
  ];
  this.isHidden = () => {
    const reduxState = store.getState();
    let isShowSlabTool = reduxState.sqftSlabState.isShowSlabTool;

    const shape = this.getGrandParent();

    return !!(
      isShowSlabTool
      || (shape && shape.shapeCabinet)
      || (shape && shape.shapeSpacer)
    );
  }
  this.setPos = (value) => {
    this.pos = value
  }
  this.setPosSlab = (value) => {
    this.posSlab = value
  }
  this.isWithAngle = () => {
    return this.angle > 0
  }
  this.isWithCorner = () => {
    return this.arcLength > 0
  }
  //private functions
  // var snappedPos = function(pos) {
  //   var scaledGridSize = sqftConfig.workspace.getScaledGridSize(),
  //     newX = Math.round(self.x / scaledGridSize) * scaledGridSize,
  //     newY = Math.round(self.y / scaledGridSize) * scaledGridSize;
  //
  //   return {
  //     x: newX,
  //     y: newY
  //   };
  // };
  this.getMiteredFeatureId = () => {
    return state.miteredFeatureId
  }
  this.setMiteredFeatureId = (id) => {
    state.miteredFeatureId = id
  }
  const setPointWasChangedInRegularMode = () => {
    const regularMode = SqftStore.isRegularMode();
    regularMode ? setPointWasChanged() : null;
  }
  const setPointWasChanged = () => {
    let parent = this.getParent();
    if (parent && parent.hasOwnProperty('getParent')) {
      let shape = parent.getParent();
      if (shape instanceof line) {
        shape.getParent().setIsPointsChanged(true);
      } else if (shape instanceof sqftShape) {
        shape.setIsPointsChanged(true);
      }
    }
  }
  const setPointWasMoved = () => {
    let parent = this.getParent();
    if (parent && parent.hasOwnProperty('getParent')) {
      let shape = parent.getParent();
      if (shape instanceof line) {
        shape.getParent().isPointsMoved = true;
      } else if (shape instanceof sqftShape) {
        shape.isPointsMoved = true;
      }
    }
  }
  const isMovable = () => {
    let shape = parent.getParent();

    return (state.isMovable || shape.getState().isPointsMovable);
  }

  function setTranslates() {
    switch (self.pointDirection) {
      case "lefttop":
        translateX = -10;
        translateY = -9;
        break;
      case "righttop":
        translateX = 9;
        translateY = -9;
        break;
      case "rightbottom":
        translateX = 9;
        translateY = 10;
        break;
      case "leftbottom":
        translateX = -10;
        translateY = 10;
        break;
      default:
        translateX = 0;
        translateY = 0;
        break;
    }
  }

  const onMouseMove = (mousePos, e) => {
    state.mousePos = mousePos;
    state.isHovering = this.isOverPointField();
    if (e.terminate) {
      state.isHovering = false;
      return false;
    }

    if (state.mouseDown) {
      EventManager.setCursor('move', this, true);
      if (isMovable()) {
        if (shouldResetSlabModePopupOnPointMoveBeDisplayed(this.getGrandParent())) {
          renderResetSeamPopup(this.getGrandParent());
        } else {
          this.movePosition(mousePos);
        }
      }
    }

    if (sqftConfig.highlight.points && state.isHovering) {
      EventManager.stealCursor();
      EventManager.setCursor('pointer', self);
      return true;
    } else {
      EventManager.resetCursor(self);
    }
    return false;
  }

  const onMouseUp = (mousePos, e) => {
    void mousePos;
    void e;
    state.mouseDown = false;
    state.mouseDownPosition = null;
    // if (state.isHovering) {
    //   let shape = parent.getParent();
    //   if (shape instanceof sqftShape) {
    //     shape.setIsPointsMovable(false);
    //   }
    // }
  }
  const canPointBeMoved = () => {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    const isShowSlabTool = reduxState.sqftSlabState.isShowSlabTool;

    // const disallowedNavItems = [
    //   SIDEBAR_NAVIGATION_BUTTONS.edge,
    //   SIDEBAR_NAVIGATION_BUTTONS.rotate,
    //   SIDEBAR_NAVIGATION_BUTTONS.text,
    //   SIDEBAR_NAVIGATION_BUTTONS.angle,
    //   SIDEBAR_NAVIGATION_BUTTONS.backsplash,
    //   SIDEBAR_NAVIGATION_BUTTONS.bumpout,
    //   SIDEBAR_NAVIGATION_BUTTONS.corners,
    //   SIDEBAR_NAVIGATION_BUTTONS.radius,
    //   SIDEBAR_NAVIGATION_BUTTONS.resize,
    //   SIDEBAR_NAVIGATION_BUTTONS.label,
    //   SIDEBAR_NAVIGATION_BUTTONS.appliances,
    //   SIDEBAR_NAVIGATION_BUTTONS.mitered,
    //   SIDEBAR_BUTTONS_MENU.delete
    // ];

    const allowedNavItems = allowedNavItemsForMovingPoint;

    const shape = parent.getParent();
    let isLineWithBumpout = false;
    let isPrevLineWithBumpout = false;
    if (shape instanceof sqftShape) {
      const prevLine = shape.getPrevLine(parent);
      isLineWithBumpout = this.getParent().isWithBumpout();
      isPrevLineWithBumpout = prevLine.isWithBumpout();
    }

    return state.canBeMoved
      //&& !disallowedNavItems.includes(activeButton) // allow move points only when this button is not active
      && allowedNavItems.includes(activeButton)  // allow move points only when button is active
      && !isShowSlabTool
      && !isLineWithBumpout
      && !isPrevLineWithBumpout
      && !this.isWithAngle()
      && !this.isWithCorner()
      ;
  }

  const onMouseDown = (mousePos, e) => {
    void mousePos;
    void e;
    if (state.isHovering && canPointBeMoved()) {
      let shape = parent.getParent();
      if (shape instanceof sqftShape) {
        shape.setIsPointsMovable(true);
      }
      state.mouseDown = true;
      state.mouseDownPosition = mousePos;
      //console.log("state.mouseDown", state.mouseDown);
      return true;
    }

    if (state.isHovering) {
      // Set shape point with mitered edge id
      if (parent instanceof MiteredOverlay) {
        const miteredPoints = parent.getPoints();
        if (this.id === miteredPoints[miteredPoints.length - 1].id || this.id === miteredPoints[0].id) {
          const hoveredPoint = workspace.getHoverPoint();
          hoveredPoint.addEdgeToPoint();
        }
      }
    }
    return false;
  }
  this.addEdgeToPoint = () => {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (activeButton === SIDEBAR_NAVIGATION_BUTTONS.edge) {
      const featureId = reduxState.sqftMenuState.activeSubMenuButton;
      this.setMiteredFeatureId(featureId);
    }
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }

  this.movePosition = (mousePos) => {
    let scale = workspace.getScale();
    let xDiff = (state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (state.mouseDownPosition.y - mousePos.y) / scale;

    state.mouseDownPosition.x = mousePos.x;
    state.mouseDownPosition.y = mousePos.y;
    this.pos.x -= xDiff;
    this.pos.y -= yDiff;
    this.revertPositionIfHasIntersections(xDiff, yDiff);
    setPointWasChangedInRegularMode();
    setPointWasMoved();
    state.pointWasMoved = true;
  }
  this.revertPositionIfHasIntersections = (xDiff, yDiff) => {
    let shape = parent.getParent();
    let isShapeHasIntersections = false;
    if (shape instanceof sqftShape) {
      isShapeHasIntersections = shape.isShapeHasIntersections();
      //console.log("isShapeHasIntersections", isShapeHasIntersections);
      if (isShapeHasIntersections) {
        this.pos.x += xDiff;
        this.pos.y += yDiff;
      }
    }
  }
  //private property setters
  function setParent(value) { parent = value; }

  //private functions

  //public functions
  this.export = () => {
    let exportPoint = {};
    this.exportAndImportProperties.forEach((property) => {
      exportPoint[property] = clone(this[property]);
    });
    return exportPoint;
  };
  this.import = (importPoint) => {
    this.exportAndImportProperties.forEach((property) => {
      this[property] = clone(importPoint[property]);
    });
    //compatibility with old visualizer
    if (!importPoint["pos"] && importPoint["x"] !== undefined && importPoint["y"] !== undefined ) {
      this.pos = { x: clone(importPoint["x"]), y: clone(importPoint["y"])}
    }
  };
  this.isHovering = function() { return state.isHovering; };
  this.getParent = function() { return parent };
  this.getGrandParent = () => {
    const parent = this.getParent();
    if (parent && parent.getParent) {
      return parent.getParent();
    }
    return null
  };
  this.isOverPointField = () => {
    let field = this.getPointField();

    state.isHovering = (
      state.mousePos.x >= field.x - this.arcLength - this.angle &&
      state.mousePos.x <= field.x + field.width + this.arcLength + this.angle &&
      state.mousePos.y >= field.y - this.arcLength - this.angle &&
      state.mousePos.y <= field.y + field.height + this.arcLength + this.angle
    );

    return state.isHovering;
  };
  this.getAngle = function () {
    return this.angle;
  };
  this.getArcLength = function () {
    return this.arcLength;
  };
  this.removeAttachedItem = function () {
    this.arcLength = 0;
    this.angle = 0;
    this.setMiteredFeatureId(null);
    sqftShapeManager.updateMinMaxMiteredPoints(this.getGrandParent());
    //reset seam shape changes in the slab mode
    sqftShapeManager.resetShapeChangesInTheSlabMode(this.getGrandParent());
  };
  this.rotate = (origin, angle, isSlabMode) => {
    let ret = {x: 0, y: 0};
    let tr = {x: this.x - origin.x, y: this.y - origin.y};

    ret.x = tr.x * Math.cos(angle) - tr.y * Math.sin(angle);
    ret.y = tr.x * Math.sin(angle) + tr.y * Math.cos(angle);

    //console.log("isSlabMode in point rotation", isSlabMode)
    const xPos = Math.round10(Math.round10(ret.x, -5) + Math.round10(origin.x, -5), -5);
    const yPos = Math.round10(Math.round10(ret.y, -5) + Math.round10(origin.y, -5), -5);
    isSlabMode ? this.setPosSlab({x: xPos, y: yPos}) : this.setPos({x: xPos, y: yPos});
  };
  this.getPointDirection =function () {
    return this.pointDirection
  };
  this.changeCornerDirection = function(line1, line2) {

    // console.log('line1', line1);
    // console.log('line2', line2);

    if (line1.orientation === "vertical" && line1.newDirection === "north"
      && line2.orientation === "horizontal" && line2.newDirection === "west") {
      this.pointDirection = "leftbottom";
    }
    if (line1.orientation === "horizontal" && line1.newDirection === "east"
      && line2.orientation === "vertical" && line2.newDirection === "north") {
      this.pointDirection = "lefttop";
    }
    if (line1.orientation === "vertical" && line1.newDirection === "south"
      && line2.orientation === "horizontal" && line2.newDirection === "east") {
      this.pointDirection = "righttop";
    }
    if (line1.orientation === "horizontal" && line1.newDirection === "west"
      && line2.orientation === "vertical" && line2.newDirection === "south") {
      this.pointDirection = "rightbottom";
    }

    if (line1.orientation === "vertical" && line1.newDirection === "north"
      && line2.orientation === "horizontal" && line2.newDirection === "east") {
      this.pointDirection = "lefttop";
    }
    if (line1.orientation === "horizontal" && line1.newDirection === "east"
      && line2.orientation === "vertical" && line2.newDirection === "south") {
      this.pointDirection = "righttop";
    }
    if (line1.orientation === "vertical" && line1.newDirection === "south"
      && line2.orientation === "horizontal" && line2.newDirection === "west") {
      this.pointDirection = "rightbottom";
    }
    if (line1.orientation === "horizontal" && line1.newDirection === "west"
      && line2.orientation === "vertical" && line2.newDirection === "north") {
      this.pointDirection = "leftbottom";
    }

  };
  this.getPointField = (useFieldWidth = true) => {
    const isCabinet = isSFTCabinetsGroup();
    let fieldWidth = isCabinet ? sqftConfig.fieldWidthCabinet : sqftConfig.fieldWidth,
      center = fieldWidth / 2,
      scale = workspace.getScale(),
      offset = parent.getOffset();

    return {
      x: (this.x * scale) + offset.x - (useFieldWidth ? center : 0),
      y: (this.y * scale) + offset.y - (useFieldWidth ? center : 0),
      height: fieldWidth,
      width: fieldWidth
    };
  };

  this.getPointPosOnWorkspace = (shouldGetRegularPosition) => {
    const shp = this.getGrandParent();
    let position;
    if (shp) {
      position = shouldGetRegularPosition && shp.pos ? shp.pos : shp.getPosition();
    } else {
      position = shouldGetRegularPosition && parent.pos ? parent.pos : parent.getPosition();
    }
    const x = shouldGetRegularPosition ? +this.pos.x : +this.x;
    const y = shouldGetRegularPosition ? +this.pos.y : +this.y;

    return {
      x: x + position.x,
      y: y + position.y,
    };
  };

  this.getPointCords = () => {
    let pointField = this.getPointField();

    return {
      x: pointField.x + pointField.width / 2,
      y: pointField.y + pointField.width / 2
    }
  };

  this.snapToGrid = () => {
    /*var pos = snappedPos();
    this.x = pos.x;
    this.y = pos.y;*/
  };

  this.destroy = function(protect) {
    if (!protect) {
      EventManager.removeEvent(self);
      pointRadiusOverlay.destroy();
    }
  };

  this.init = function(parent) {
    setParent(parent);
    this.initEvents();
    pointRadiusOverlay = new PointRadius();
    pointRadiusOverlay.init(self);
  };
  this.initEvents = () => {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      self,
      EventManager.priorities.POINT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      self,
      EventManager.priorities.POINT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      onMouseUp,
      self,
      EventManager.priorities.POINT
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      self,
      EventManager.priorities.POINT
    );
  };
  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
  };
  this.reInitEvents = () => {
    this.initEvents();
  };
  this.deregisterPartEvents = () => {
    if (pointRadiusOverlay) {
      pointRadiusOverlay.deregisterPartEvents();
    }
  };
  this.reInitPartEvents = () => {
    if (pointRadiusOverlay) {
      pointRadiusOverlay.reInitPartEvents();
    }
  };
  // check if corner can be applied to another side of the line
  this.isFitSize = function () {
    if (parent.isLine) {
      let fitSize = new FitSize(parent);

      return fitSize.isFitSize(SqftStore.radius.angle ||  SqftStore.radius.arcLength);
    }
    return true
  };

  this.isWithoutMitered = function () {
    return !(this.getParent() ? this.getParent().isWithMitered() : false)
      && !(this.getParent() ? this.getParent().isWithMiteredPrev() : false)
  };
  this.rememberPos = () => {
    this.backupX = this.x;
    this.backupY = this.y;
  }
  this.restorePos = () => {
    this.x = this.backupX;
    this.y = this.backupY;
  }

  this.render = (ctx) => {
    if (workspace && workspace.getState().loading) {
      return
    }

    if (isDisabledInPopupShouldBeHidden() && isDisabledInPopupWithParents(this)) {
      return
    }

    if (this.isHidden()) { return; }
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    const o = parent.getOffset();
    let
      pointField = self.getPointField(),
      scale      = sqftConfig.scale,
      marginX,
      marginY;

    switch (this.pointDirection) {
      case "lefttop":
        marginX = -13;
        marginY = -13;
        break;
      case "righttop":
        marginX = 5;
        marginY = -13;
        break;
      case "rightbottom":
        marginX = 5;
        marginY = self.pointDiff ? 5 - self.pointDiff : 5;
        break;
      case "leftbottom":
        marginX = self.pointDiff ? -13 + self.pointDiff : -13;
        marginY = 5;
        break;
      default:
        marginX = 0;
        marginY = 0;
        break;
    }

    let pos = {
      x: o.x + (this.x * scale) + marginX,
      y: o.y + (this.y * scale) + marginY
    };

    let pos2 = {
      x: o.x + (this.x * scale),
      y: o.y + (this.y * scale)
    };
    void pos2;

    const shouldHighLightRadius = sqftConfig.highlight.points
      && !(this.arcLength > 0 || this.angle > 0)
      && !self.angleIsChanged
      && this.isFitSize();

    const isNotHighlighted = !(sqftConfig.highlight.points && !(this.arcLength > 0 || this.angle > 0))
      || sqftConfig.highlight.points && !this.isFitSize();

    ctx.save();
    ctx.beginPath();

    if (this.layout === 'white-circle') {
      this.renderCircleLayout(ctx, pointField);

      if (EventManager.getCursor().indexOf("delete") >= 0 && state.isHovering && parent instanceof MiteredOverlay) {
        ctx.fillStyle = fillStyleDelete;
      } else {
        ctx.fillStyle = fillStyleWhite;
      }
      ctx.fill();

    } else if (this.layout === 'small-white-circle' || state.isHovering && canPointBeMoved()) {
      this.renderSmallCircleLayout(ctx, pointField);

    } else if (this.layout === 'black-circle') {
      this.renderCircleLayout(ctx, pointField);
      ctx.fillStyle = fillStyleBlack;
      ctx.fill();

    } else if (this.layout === 'arrow-circle') {
      this.renderArrowCircleLayout(ctx, pointField);

    } else if (this.layout === 'blank') {
      this.renderBlankLayout(ctx, pos);

    } else if (shouldHighLightRadius) {
      this.renderHighlightRadiusLayout(ctx, pointField);

    } else if (sqftConfig.highlight.rotateAngle && this.renderAngleCircle) {
      this.renderRotateAngleLayout(ctx, pointField);

    } else {
      if (this.getMiteredFeatureId()) {
        ctx.fillStyle = fillStyleEdge
      } else {
        ctx.fillStyle = fillStyle;
      }

      if (this.arcLength > 0 || this.angle > 0) {
        //this.renderArcLayoutOld(ctx, pointField, pos);

      } else if (isNotHighlighted) {
        if (allowedNavItemsForMovingPoint.includes(activeButton)) {
          this.renderWhitePointLayout(ctx, pos2);
        } else {
          // old gray rectangle
          //this.renderGrayPointLayoutV2(ctx, pos);

          // gray rectangle version 2
          this.renderGrayPointLayoutV2(ctx);
        }
      }
    }

    ctx.closePath();
    ctx.restore();
  };

  this.renderRotateAngleLayout = (ctx, pointField) => {
    //todo fix bumpout rotation and remove this
    ////////////////////////////////////////////////
    if (!parent.getParent().isWithBumpout()
      && !parent.getParent().isWithMitered()
      && !parent.getParent().isPointsMoved
      && parent.getParent().rotatedDegrees === 0
    ) {
      ///////////////////////////////////
      setTranslates();
      ctx.arc(
        pointField.x + translateX + pointField.width / 2,
        pointField.y + translateY - 2 + pointField.width / 2,
        this.renderAngleCircle,
        0,
        2 * Math.PI
      );
      ctx.closePath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
      ctx.fillStyle = "rgba(159, 197, 34, 0.25)";
      ctx.fill();
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(pointField.x + 45 / 2 + translateX + 2, pointField.y + 45 / 2 + translateY, this.renderAngleCircle / 2, 0, 2 * Math.PI);
      ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
      ctx.fill();
      ctx.closePath();

      if (this.renderAngleArc) {
        ctx.beginPath();
        ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
        ctx.arc(
          pointField.x + translateX + 4 + pointField.width / 2,
          pointField.y + pointField.width / 2,
          this.renderAngleArc,
          0,
          Math.PI / 2
        );
        ctx.stroke();
      }
    }
  }

  this.renderHighlightRadiusLayout = (ctx, pointField) => {
    //todo hide if override

    setTranslates();
    ctx.arc(
      pointField.x + translateX + pointField.width / 2,
      pointField.y + translateY + pointField.width / 2,
      pointField.width / 2,
      0,
      2 * Math.PI
    );
    ctx.closePath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = radiusFillStyle;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(pointField.x + 45/2 + translateX + 2, pointField.y + 45/2 + translateY, 8, 0, 2 * Math.PI, false);
    ctx.fillStyle = radiusFillStyle;
    ctx.fill();
  }

  this.renderCircleLayout = (ctx, pointField) => {
    setTranslates();
    ctx.arc(
      pointField.x + translateX + pointField.width / 2,
      pointField.y + translateY + pointField.width / 2,
      9,
      0,
      2 * Math.PI
    );
    ctx.closePath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = fillStyleBlack;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(
      pointField.x + translateX + pointField.width / 2,
      pointField.y + translateY + pointField.width / 2,
      8,
      0,
      2 * Math.PI,
      false
    );
  }

  this.renderSmallCircleLayout = (ctx, pointField) => {
    let arcRadius;
    ctx.lineWidth = 2;
    if (state.isHovering) {
      arcRadius = 6
      ctx.fillStyle = COLOR.blackLight;
    } else {
      arcRadius = 5
      ctx.fillStyle = COLOR.white;
    }

    ctx.arc(
      pointField.x + pointField.width / 2,
      pointField.y + pointField.width / 2,
      arcRadius,
      0,
      2 * Math.PI,
      false
    );

    ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;

    ctx.stroke();
    ctx.fill();
  }

  this.renderBlankLayout = (ctx, pos) => {
    ctx.rect(pos.x, pos.y, 1, 1); // draw simple rectangle
    ctx.fill();
  }

  this.renderArrowCircleLayout = (ctx, pointField) => {
    setTranslates();

    ctx.beginPath();
    ctx.arc(
      pointField.x + translateX + pointField.width / 2,
      pointField.y + translateY + pointField.width / 2,
      10,
      0,
      2 * Math.PI,
      false
    );
    ctx.fillStyle = fillStyleBlue;
    ctx.fill();
  }

  this.renderGrayPointLayout = (ctx, pos) => {
    ctx.rect(pos.x, pos.y, 8, 8); // draw simple rectangle
    ctx.fillStyle = 'rgba(205,202,202,0.5)';
    ctx.fill();
    ctx.closePath();
  }

  this.renderArcLayoutOld = (ctx, pointField, pos) => {
    console.log('pointField.x', pointField.x);
    console.log('pointField.y', pointField.y);
    console.log('radius', this.arcLength);

    ctx.beginPath();
    ctx.lineWidth = 8;
    ctx.strokeStyle = radiusFillStyle;
    ctx.strokeStyle = "#b263a8";
    ctx.moveTo(pointField.x + 15, pointField.y + 45);             // P0
    ctx.arcTo(pointField.x + 15, pointField.y + 15, pointField.x + 45, pointField.y + 15, 30); // P1, P2 and the radius
    ctx.stroke();
    console.log('stroked2!');

    ctx.moveTo(pos.x, pos.y);
    ctx.arcTo(pos.x, pos.y, pos.x + 15, pos.y + 15, this.arcLength); // draw arc radius
    ctx.stroke();
    console.log('stroked!');
  }

  this.renderGrayPointLayoutV2 = (ctx) => {
    ctx.beginPath();
    const shape = parent.getParent();
    const nextLine = shape.getNextLine(parent);
    //const prevLine = shape.getPrevLine(parent);
    const angleBetweenTwoLines = getAngleBetween3Points(parent.from, parent.to, nextLine.to);
    //console.log("angleBetweenTwoLines", angleBetweenTwoLines);

    void angleBetweenTwoLines;

    const pointOnTheLine = getPointOnTheLine(
      parent.to.getPointField(false),
      parent.from.getPointField(false),
      15
    );
    const pointOnTheNextLine = getPointOnTheLine(
      nextLine.from.getPointField(false),
      nextLine.to.getPointField(false),
      15
    );
    const midpoint = getMidPoint(pointOnTheLine, pointOnTheNextLine);
    let posX = midpoint.x; //o.x + (midpoint.x * scale);
    let posY = midpoint.y; //o.y + (midpoint.y * scale);
    void posX;
    void posY;

    ctx.rect(
      posX - 4,
      posY - 4,
      8, 8
    ); // draw simple rectangle
    ctx.fillStyle = 'rgba(205,202,202,0.5)';
    ctx.fill();
  }

  this.renderWhitePointLayout = (ctx, pos2) => {
    ctx.arc(
      pos2.x,
      pos2.y,
      5,
      0,
      2 * Math.PI
    );
    ctx.fillStyle = 'rgb(255,255,255)';
    ctx.fill();
    ctx.lineWidth = 2;
    ctx.strokeStyle = fillStyleBlue;
    ctx.stroke();
  }
}
